<template>
    <div class="person-container">
        <div class="person-wrapper" v-for="person in persons">
            <div class="person">
                <img :src="image(person)">
                <span class="name">{{person.name}} {{person.surname}}</span>
                <span class="role">{{$t(person.role)}}</span>
            </div>
        </div>
    </div>
</template>

<script>
let images = require.context("../../assets/img/crew_cast/at", false, /\.jpg$/);

export default {
  name: "group-creative",
  methods: {
    image: function(person) {
      return images("./" + person.surname + "-" + person.name + ".jpg");
    }
  },
  data: function() {
    return {
      persons: [
        {
          name: "Birgit",
          surname: "Minichmayr",
          role: "creative.music-text"
        },
        {
          name: "Hannes",
          surname: "Minichmayr",
          role: "creative.producer"
        },
        {
          name: "Franz",
          surname: "Braun",
          role: "creative.director"
        },
        {
          name: "Johannes",
          surname: "Mertl",
          role: "creative.vocal-coach"
        },
        {
          name: "Marlis",
          surname: "Birkner",
          role: "creative.choir"
        },
        {
          name: "Annika",
          surname: "Lämmle",
          role: "creative.choir-master"
        },
        {
          name: "Cornelius",
          surname: "Schock",
          role: "creative.arrangements"
        },
        {
          name: "Markus",
          surname: "Herzer",
          role: "creative.arrangements"
        },
        {
          name: "Carina",
          surname: "Gruber",
          role: "creative.choreography"
        },
        {
          name: "Magdalena",
          surname: "Kritzinger",
          role: "creative.choreography"
        },
        {
          name: "Eva",
          surname: "Butzkies",
          role: "creative.costumes"
        },
        {
          name: "Hanna",
          surname: "Penatzer",
          role: "creative.stage"
        },
        {
          name: "Andrea",
          surname: "Uebel",
          role: "creative.props"
        },
        {
          name: "Piroska",
          surname: "Kainrath",
          role: "creative.makeup"
        },
        {
          name: "Johannes",
          surname: "Minichmayr",
          role: "creative.sound"
        },
        {
          name: "Stefan",
          surname: "Lukesch",
          role: "creative.light"
        }
      ]
    };
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/person";
</style>



// WEBPACK FOOTER //
// src/components/MainSegments/GroupCreative.vue